const DRAWER_PARAMS = [
  'listing',
  'reservation',
  'owner',
  'expense',
  'deposit',
  'transfer',
  'bankRecord',
  'connection',
  'payment',
  'payout',
  'transfer',
];

export const removeDrawerStateFromUrl = () => {
  const url = new URL(window.location.href);
  DRAWER_PARAMS.forEach((param) => {
    url.searchParams.delete(param);
  });
  window.history.replaceState({}, '', url.toString());
};
